import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconExclamationCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconExclamationCircle"><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><Path d="M12 7.75V12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Circle cx="12" cy="16" r="1" fill="currentColor"/></CentralIconBase>;
});

export default IconExclamationCircle;
